<template>
  <div class="a-accordion">
    <button class="gui-btn gui-btn--red gui-btn--w-207" @click.prevent="onUpdateClick">{{$t('buttons.upload-from-1C')}}</button>

    <nomenclature-catalog-item :item="item"
                               v-for="item in visibleItems"
                               :key="item.id">
    </nomenclature-catalog-item>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import NomenclatureCatalogItem from "./NomenclatureCatalogItem";
  import Loading from '@/components/Loading'
  import Errors from '@/api/types/errors'

  export default {
    components: {
      NomenclatureCatalogItem,
      Loading
    },

    computed: {
      items() {
        return this.$store.getters.nomenclature.items;
      },

      visibleItems() {
        let items = [];

        let collapsedLevel;

        for (let i = 0; i < this.items.length; ++i) {
          if (collapsedLevel !== undefined && this.items[i].level > collapsedLevel) {
            continue
          }
          else {
            collapsedLevel = undefined;
          }

          items.push(this.items[i]);

          if (this.items[i].collapsed) {
            collapsedLevel = this.items[i].level;
          }
        }

        return items;
      }
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.commit('clearNomenclatureCatalog');
          await this.$store.dispatch('fetchNomenclatureCatalog');
        }
        catch(e) {
          console.error(e);
        }
      });
    },

    methods: {
      onUpdateClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('syncNomenclatureWith1C');

            this.showError({
              title: 'captions.sync-with-1C',
              error: 'captions.sync-with-1C-is-done'
            });
          }
          catch(e) {
            console.error('unable to sync data with 1C', e);

            let error;
            let label;

            if (!e instanceof Errors) {
              error = new Errors(Errors.UNKNOWN);
              label = error.label;
            }
            else if (e.ALREADY_EXISTS) {
              label = 'errors.catalog.nomenclature.uploading-in-progress';
            }
            else if (e.NOT_FOUND) {
              label = 'errors.catalog.nomenclature.empty-catalog';
            }
            else if (e.ACCESS_DENIED) {
              label = 'errors.catalog.nomenclature.access-denied';
            }
            else if (e.INVALID_DATA) {
              label = 'errors.catalog.nomenclature.sync-failed';
            }
            else {
              console.warn('unknown error');
              label = e.label;
            }

            this.showError({
              error: label
            })
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
